import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[100] bg-background flex flex-col"
}
const _hoisted_2 = { class: "h-14 border-b px-6 py-3 flex items-center justify-between shrink-0" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-lg font-semibold truncate" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "flex-1 min-h-0 overflow-auto" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center py-12"
}
const _hoisted_8 = {
  key: 1,
  class: "max-w-3xl mx-auto p-6"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = {
  key: 1,
  class: "text-center py-16"
}
const _hoisted_12 = {
  key: 2,
  class: "text-center py-12"
}
const _hoisted_13 = { class: "text-sm text-muted-foreground" }
const _hoisted_14 = {
  key: 3,
  class: "space-y-2"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-sm font-medium truncate" }
const _hoisted_18 = { class: "flex items-center gap-2 text-xs text-muted-foreground mt-0.5 flex-wrap" }
const _hoisted_19 = { class: "flex items-center gap-1" }
const _hoisted_20 = {
  key: 1,
  class: "flex items-center gap-1"
}
const _hoisted_21 = {
  key: 0,
  class: "text-xs text-muted-foreground/70 mt-0.5 truncate"
}
const _hoisted_22 = { class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity shrink-0" }
const _hoisted_23 = {
  key: 2,
  class: "max-w-3xl mx-auto p-6"
}
const _hoisted_24 = { class: "mb-4 flex items-center gap-2 text-xs text-muted-foreground" }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_26 = {
  key: 1,
  class: "text-muted-foreground/70"
}
const _hoisted_27 = {
  key: 0,
  class: "text-sm text-muted-foreground mb-4"
}
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_30 = {
  key: 0,
  class: "border rounded-lg p-4 space-y-4 bg-muted/30"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-sm font-semibold mb-1 flex items-center gap-1.5" }
const _hoisted_33 = { class: "text-sm leading-relaxed" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "text-sm font-semibold mb-1 flex items-center gap-1.5" }
const _hoisted_36 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "text-sm font-semibold mb-1 flex items-center gap-1.5" }
const _hoisted_39 = { class: "text-sm space-y-1 list-disc list-inside" }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { class: "text-sm font-semibold mb-1 flex items-center gap-1.5" }
const _hoisted_42 = { class: "text-sm space-y-1 list-disc list-inside" }
const _hoisted_43 = { key: 4 }
const _hoisted_44 = { class: "text-sm font-semibold mb-1 flex items-center gap-1.5" }
const _hoisted_45 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_46 = { key: 5 }
const _hoisted_47 = { class: "text-sm font-semibold mb-1 flex items-center gap-1.5" }
const _hoisted_48 = { class: "text-xs text-muted-foreground mb-1 italic" }
const _hoisted_49 = { class: "text-sm whitespace-pre-wrap leading-relaxed bg-background rounded p-3 border" }
const _hoisted_50 = { class: "flex items-center gap-2" }
const _hoisted_51 = { class: "flex items-center gap-2 pt-1" }
const _hoisted_52 = { class: "text-xs text-muted-foreground ml-auto" }
const _hoisted_53 = {
  key: 1,
  class: "border rounded-lg p-6 flex flex-col items-center justify-center gap-2 bg-muted/30"
}
const _hoisted_54 = {
  key: 1,
  class: "flex items-center justify-center py-8"
}
const _hoisted_55 = {
  key: 2,
  class: "text-center py-8 border rounded-lg"
}
const _hoisted_56 = {
  key: 3,
  class: "space-y-2"
}
const _hoisted_57 = { class: "flex items-start gap-2" }
const _hoisted_58 = { class: "flex items-center gap-1.5 text-xs text-muted-foreground shrink-0 mt-0.5 w-16" }
const _hoisted_59 = { class: "text-muted-foreground/50" }
const _hoisted_60 = { class: "flex-1 min-w-0" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "flex items-center gap-2 mt-2" }
const _hoisted_63 = {
  key: 1,
  class: "text-sm leading-relaxed"
}
const _hoisted_64 = {
  key: 0,
  class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity shrink-0"
}

import { ref, computed, watch } from 'vue'
import { useVoiceNotesWidget } from '@/composables/useVoiceNotesWidget'
import { useVoiceNotesStore } from '@/views/VoiceNotes/store'
import { useToast } from '@/components/ui/toast'
import type { VoiceSession, VoiceFragment } from '@/views/VoiceNotes/types'

import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Separator } from '@/components/ui/separator'
import {
  Mic,
  Clock,
  ChevronLeft,
  Trash2,
  Pencil,
  Check,
  X,
  Minus,
  Loader2,
  MessageSquareText,
  Hash,
  RefreshCw,
  Search,
  BrainCircuit,
  Sparkles,
  Send,
  RotateCcw,
  CircleHelp,
  Users,
  ListChecks,
  Tags,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'VoiceNotesPanel',
  setup(__props) {

const { isOpen, minimize, close } = useVoiceNotesWidget()
const store = useVoiceNotesStore()
const { toast } = useToast()

// View state
const view = ref<'list' | 'detail'>('list')
const showDeleteSession = ref(false)
const showDeleteFragment = ref(false)
const sessionToDelete = ref<VoiceSession | null>(null)
const fragmentToDelete = ref<VoiceFragment | null>(null)
const editingFragmentId = ref<number | null>(null)
const editingFragmentText = ref('')
const editingSessionId = ref<number | null>(null)
const editingSessionName = ref('')
const searchQuery = ref('')
const showAnalysis = ref(false)
const customPrompt = ref('')
const showDeleteAnalysis = ref(false)

const filteredSessions = computed(() => {
  const q = searchQuery.value.trim().toLowerCase()
  if (!q) return store.sessions
  return store.sessions.filter((s) =>
    s.name.toLowerCase().includes(q) ||
    (s.description && s.description.toLowerCase().includes(q)) ||
    (s.tags && s.tags.toLowerCase().includes(q))
  )
})

// Load all sessions when panel opens
watch(isOpen, (open) => {
  if (open) {
    view.value = 'list'
    searchQuery.value = ''
    store.clearFragments()
    store.fetchAllSessions()
  }
})

const formatDuration = (seconds: number | null): string => {
  if (!seconds) return '0s'
  const mins = Math.floor(seconds / 60)
  const secs = Math.round(seconds % 60)
  if (mins === 0) return `${secs}s`
  return `${mins}m ${secs}s`
}

const formatDate = (dateStr: string): string => {
  const d = new Date(dateStr)
  return d.toLocaleDateString('es-CL', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

const statusLabels: Record<string, string> = {
  active: 'Activa',
  completed: 'Completada',
  archived: 'Archivada',
}

const statusColors: Record<string, string> = {
  active: 'bg-green-500/10 text-green-600',
  completed: 'bg-blue-500/10 text-blue-600',
  archived: 'bg-gray-500/10 text-gray-600',
}

const entityLabel = (session: VoiceSession): string | null => {
  if (session.projectId) return 'Proyecto'
  if (session.applicationId) return 'Aplicacion'
  if (session.meetingId) return 'Reunion'
  return null
}

// Session actions
const openSession = (session: VoiceSession) => {
  store.fetchFragments(session.id)
  store.fetchAnalysis(session.id)
  showAnalysis.value = false
  view.value = 'detail'
}

const goBack = () => {
  view.value = 'list'
  showAnalysis.value = false
  customPrompt.value = ''
  store.clearFragments()
}

// Analysis actions
const runAnalysis = async () => {
  if (!store.currentSession) return
  try {
    await store.analyzeSession(store.currentSession.id)
    showAnalysis.value = true
    toast({ title: 'Análisis generado' })
  } catch {
    toast({ title: 'Error al analizar la sesión', variant: 'destructive' })
  }
}

const runCustomPrompt = async () => {
  if (!store.currentSession || !customPrompt.value.trim()) return
  try {
    await store.analyzeCustom(store.currentSession.id, customPrompt.value.trim())
    customPrompt.value = ''
    toast({ title: 'Análisis personalizado generado' })
  } catch {
    toast({ title: 'Error al ejecutar prompt personalizado', variant: 'destructive' })
  }
}

const confirmDeleteAnalysis = () => {
  showDeleteAnalysis.value = true
}

const doDeleteAnalysis = async () => {
  if (!store.currentSession) return
  try {
    await store.deleteAnalysis(store.currentSession.id)
    showAnalysis.value = false
    toast({ title: 'Análisis eliminado' })
  } catch {
    toast({ title: 'Error al eliminar análisis', variant: 'destructive' })
  } finally {
    showDeleteAnalysis.value = false
  }
}

const startEditSession = (session: VoiceSession) => {
  editingSessionId.value = session.id
  editingSessionName.value = session.name
}

const saveSessionName = async () => {
  if (!editingSessionId.value || !editingSessionName.value.trim()) return
  try {
    await store.updateSession(editingSessionId.value, { name: editingSessionName.value.trim() })
    toast({ title: 'Sesion actualizada' })
  } catch {
    toast({ title: 'Error al actualizar', variant: 'destructive' })
  } finally {
    editingSessionId.value = null
  }
}

const confirmDeleteSession = (session: VoiceSession) => {
  sessionToDelete.value = session
  showDeleteSession.value = true
}

const doDeleteSession = async () => {
  if (!sessionToDelete.value) return
  try {
    await store.deleteSession(sessionToDelete.value.id)
    toast({ title: 'Sesion eliminada' })
  } catch {
    toast({ title: 'Error al eliminar', variant: 'destructive' })
  } finally {
    showDeleteSession.value = false
    sessionToDelete.value = null
  }
}

// Fragment actions
const startEditFragment = (fragment: VoiceFragment) => {
  editingFragmentId.value = fragment.id
  editingFragmentText.value = fragment.text
}

const saveFragmentText = async () => {
  if (!editingFragmentId.value || !editingFragmentText.value.trim()) return
  try {
    await store.updateFragment(editingFragmentId.value, editingFragmentText.value.trim())
    toast({ title: 'Fragmento actualizado' })
  } catch {
    toast({ title: 'Error al actualizar', variant: 'destructive' })
  } finally {
    editingFragmentId.value = null
  }
}

const confirmDeleteFragment = (fragment: VoiceFragment) => {
  fragmentToDelete.value = fragment
  showDeleteFragment.value = true
}

const doDeleteFragment = async () => {
  if (!fragmentToDelete.value) return
  try {
    await store.deleteFragment(fragmentToDelete.value.id)
    toast({ title: 'Fragmento eliminado' })
  } catch {
    toast({ title: 'Error al eliminar', variant: 'destructive' })
  } finally {
    showDeleteFragment.value = false
    fragmentToDelete.value = null
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        "enter-active-class": "transition-all duration-300 ease-out",
        "leave-active-class": "transition-all duration-200 ease-in",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (_unref(isOpen))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (view.value === 'detail' && _unref(store).currentSession)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_unref(Button), {
                            variant: "ghost",
                            size: "icon",
                            class: "h-8 w-8",
                            onClick: goBack
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ChevronLeft), { class: "h-4 w-4" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Mic), { class: "h-5 w-5" }),
                          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(store).currentSession.name), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_unref(Mic), { class: "h-5 w-5" }),
                          _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "text-lg font-semibold" }, "Notas de Voz", -1)),
                          _createVNode(_unref(Badge), { variant: "outline" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(store).sessions.length), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (view.value === 'list')
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          variant: "outline",
                          size: "sm",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).fetchAllSessions())),
                          disabled: _unref(store).isLoading
                        }, {
                          default: _withCtx(() => [
                            (_unref(store).isLoading)
                              ? (_openBlock(), _createBlock(_unref(Loader2), {
                                  key: 0,
                                  class: "h-3.5 w-3.5 mr-1.5 animate-spin"
                                }))
                              : (_openBlock(), _createBlock(_unref(RefreshCw), {
                                  key: 1,
                                  class: "h-3.5 w-3.5 mr-1.5"
                                })),
                            _cache[15] || (_cache[15] = _createTextVNode(" Actualizar ", -1))
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(Button), {
                      variant: "ghost",
                      size: "icon",
                      title: "Minimizar",
                      onClick: _unref(minimize)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Minus), { class: "h-4 w-4" })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(Button), {
                      variant: "ghost",
                      size: "icon",
                      title: "Cerrar",
                      onClick: _unref(close)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(X), { class: "h-4 w-4" })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_unref(store).isLoading && view.value === 'list')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_unref(Loader2), { class: "h-6 w-6 animate-spin text-muted-foreground" })
                      ]))
                    : (view.value === 'list')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_unref(store).sessions.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
                                  _createVNode(_unref(Input), {
                                    modelValue: searchQuery.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                                    placeholder: "Buscar por titulo, descripcion o tags...",
                                    class: "pl-9"
                                  }, null, 8, ["modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(store).sessions.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_unref(Mic), { class: "h-12 w-12 text-muted-foreground mx-auto mb-3" }),
                                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-muted-foreground" }, "No hay notas de voz", -1))
                              ]))
                            : (filteredSessions.value.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_unref(Search), { class: "h-8 w-8 text-muted-foreground mx-auto mb-2" }),
                                  _createElementVNode("p", _hoisted_13, "Sin resultados para \"" + _toDisplayString(searchQuery.value) + "\"", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSessions.value, (session) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: session.id,
                                      class: "flex items-center gap-3 p-4 border rounded-lg hover:bg-muted/50 transition-colors group"
                                    }, [
                                      _createElementVNode("div", {
                                        class: "h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0 cursor-pointer",
                                        onClick: ($event: any) => (openSession(session))
                                      }, [
                                        _createVNode(_unref(Mic), { class: "h-5 w-5 text-primary" })
                                      ], 8, _hoisted_15),
                                      _createElementVNode("div", {
                                        class: "flex-1 min-w-0 cursor-pointer",
                                        onClick: ($event: any) => (openSession(session))
                                      }, [
                                        (editingSessionId.value === session.id)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "flex items-center gap-2",
                                              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                                            }, [
                                              _createVNode(_unref(Input), {
                                                modelValue: editingSessionName.value,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingSessionName).value = $event)),
                                                class: "h-7 text-sm",
                                                onKeydown: [
                                                  _withKeys(saveSessionName, ["enter"]),
                                                  _cache[3] || (_cache[3] = _withKeys(($event: any) => (editingSessionId.value = null), ["escape"]))
                                                ]
                                              }, null, 8, ["modelValue"]),
                                              _createVNode(_unref(Button), {
                                                variant: "ghost",
                                                size: "icon",
                                                class: "h-7 w-7 shrink-0",
                                                onClick: saveSessionName
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(Check), { class: "h-3.5 w-3.5" })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(Button), {
                                                variant: "ghost",
                                                size: "icon",
                                                class: "h-7 w-7 shrink-0",
                                                onClick: _cache[4] || (_cache[4] = ($event: any) => (editingSessionId.value = null))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(X), { class: "h-3.5 w-3.5" })
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("p", _hoisted_17, _toDisplayString(session.name), 1),
                                              _createElementVNode("div", _hoisted_18, [
                                                _createVNode(_unref(Badge), {
                                                  variant: "secondary",
                                                  class: _normalizeClass([statusColors[session.status], "text-[10px] px-1.5 py-0"])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(statusLabels[session.status] || session.status), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class"]),
                                                (entityLabel(session))
                                                  ? (_openBlock(), _createBlock(_unref(Badge), {
                                                      key: 0,
                                                      variant: "outline",
                                                      class: "text-[10px] px-1.5 py-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(entityLabel(session)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("span", _hoisted_19, [
                                                  _createVNode(_unref(MessageSquareText), { class: "h-3 w-3" }),
                                                  _createTextVNode(" " + _toDisplayString(session.fragmentCount), 1)
                                                ]),
                                                (session.totalDuration)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                                      _createVNode(_unref(Clock), { class: "h-3 w-3" }),
                                                      _createTextVNode(" " + _toDisplayString(formatDuration(session.totalDuration)), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("span", null, _toDisplayString(formatDate(session.createdAt)), 1)
                                              ]),
                                              (session.description)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(session.description), 1))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                      ], 8, _hoisted_16),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_unref(Button), {
                                          variant: "ghost",
                                          size: "icon",
                                          class: "h-7 w-7",
                                          onClick: _withModifiers(($event: any) => (startEditSession(session)), ["stop"]),
                                          title: "Editar nombre"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Pencil), { class: "h-3.5 w-3.5" })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_unref(Button), {
                                          variant: "ghost",
                                          size: "icon",
                                          class: "h-7 w-7 text-muted-foreground hover:text-destructive",
                                          onClick: _withModifiers(($event: any) => (confirmDeleteSession(session)), ["stop"]),
                                          title: "Eliminar sesion"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Trash2), { class: "h-3.5 w-3.5" })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                        ]))
                      : (view.value === 'detail')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              (_unref(store).currentSession?.totalDuration)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                    _createVNode(_unref(Clock), { class: "h-3 w-3" }),
                                    _createTextVNode(" " + _toDisplayString(formatDuration(_unref(store).currentSession.totalDuration)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", null, _toDisplayString(_unref(store).fragmentCount) + " fragmentos", 1),
                              (_unref(store).currentSession?.tags)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(store).currentSession.tags), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (_unref(store).currentSession?.description)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_unref(store).currentSession.description), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                (_unref(store).analysis)
                                  ? (_openBlock(), _createBlock(_unref(Button), {
                                      key: 0,
                                      variant: "outline",
                                      size: "sm",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showAnalysis.value = !showAnalysis.value))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(BrainCircuit), { class: "h-4 w-4 mr-1" }),
                                        _createTextVNode(" " + _toDisplayString(showAnalysis.value ? 'Ocultar análisis' : 'Ver análisis'), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!_unref(store).analysis && !_unref(store).isLoadingAnalysis)
                                  ? (_openBlock(), _createBlock(_unref(Button), {
                                      key: 1,
                                      variant: "outline",
                                      size: "sm",
                                      disabled: _unref(store).isAnalyzing || _unref(store).fragments.length === 0,
                                      onClick: runAnalysis
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Sparkles), { class: "h-4 w-4 mr-1" }),
                                        (_unref(store).isAnalyzing)
                                          ? (_openBlock(), _createBlock(_unref(Loader2), {
                                              key: 0,
                                              class: "h-4 w-4 animate-spin mr-1"
                                            }))
                                          : _createCommentVNode("", true),
                                        _cache[17] || (_cache[17] = _createTextVNode(" Generar análisis IA ", -1))
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]))
                                  : _createCommentVNode("", true),
                                (_unref(store).isLoadingAnalysis)
                                  ? (_openBlock(), _createBlock(_unref(Loader2), {
                                      key: 2,
                                      class: "h-4 w-4 animate-spin text-muted-foreground"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              (showAnalysis.value && _unref(store).analysis)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    (_unref(store).analysis.summary)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                          _createElementVNode("h4", _hoisted_32, [
                                            _createVNode(_unref(BrainCircuit), { class: "h-4 w-4 text-primary" }),
                                            _cache[18] || (_cache[18] = _createTextVNode(" Resumen ", -1))
                                          ]),
                                          _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(store).analysis.summary), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(store).analysis.topics.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _createElementVNode("h4", _hoisted_35, [
                                            _createVNode(_unref(Tags), { class: "h-4 w-4 text-primary" }),
                                            _cache[19] || (_cache[19] = _createTextVNode(" Temas ", -1))
                                          ]),
                                          _createElementVNode("div", _hoisted_36, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).analysis.topics, (topic) => {
                                              return (_openBlock(), _createBlock(_unref(Badge), {
                                                key: topic,
                                                variant: "secondary",
                                                class: "text-xs"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(topic), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(store).analysis.decisions.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                          _createElementVNode("h4", _hoisted_38, [
                                            _createVNode(_unref(ListChecks), { class: "h-4 w-4 text-primary" }),
                                            _cache[20] || (_cache[20] = _createTextVNode(" Decisiones ", -1))
                                          ]),
                                          _createElementVNode("ul", _hoisted_39, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).analysis.decisions, (decision, i) => {
                                              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(decision), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(store).analysis.keyQuestions.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                          _createElementVNode("h4", _hoisted_41, [
                                            _createVNode(_unref(CircleHelp), { class: "h-4 w-4 text-primary" }),
                                            _cache[21] || (_cache[21] = _createTextVNode(" Preguntas clave ", -1))
                                          ]),
                                          _createElementVNode("ul", _hoisted_42, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).analysis.keyQuestions, (q, i) => {
                                              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(q), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(store).analysis.speakers.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                          _createElementVNode("h4", _hoisted_44, [
                                            _createVNode(_unref(Users), { class: "h-4 w-4 text-primary" }),
                                            _cache[22] || (_cache[22] = _createTextVNode(" Participantes ", -1))
                                          ]),
                                          _createElementVNode("div", _hoisted_45, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).analysis.speakers, (speaker) => {
                                              return (_openBlock(), _createBlock(_unref(Badge), {
                                                key: speaker,
                                                variant: "outline",
                                                class: "text-xs"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(speaker), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(store).analysis.customResult)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                          _createVNode(_unref(Separator), { class: "my-2" }),
                                          _createElementVNode("h4", _hoisted_47, [
                                            _createVNode(_unref(Sparkles), { class: "h-4 w-4 text-primary" }),
                                            _cache[23] || (_cache[23] = _createTextVNode(" Resultado personalizado ", -1))
                                          ]),
                                          _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(store).analysis.customPrompt), 1),
                                          _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(store).analysis.customResult), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(Separator), { class: "my-2" }),
                                    _createElementVNode("div", _hoisted_50, [
                                      _createVNode(_unref(Input), {
                                        modelValue: customPrompt.value,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customPrompt).value = $event)),
                                        placeholder: "Prompt personalizado (ej: genera un acta formal...)",
                                        class: "text-sm",
                                        onKeydown: _withKeys(runCustomPrompt, ["enter"])
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_unref(Button), {
                                        variant: "default",
                                        size: "icon",
                                        class: "h-9 w-9 shrink-0",
                                        disabled: _unref(store).isAnalyzing || !customPrompt.value.trim(),
                                        onClick: runCustomPrompt
                                      }, {
                                        default: _withCtx(() => [
                                          (_unref(store).isAnalyzing)
                                            ? (_openBlock(), _createBlock(_unref(Loader2), {
                                                key: 0,
                                                class: "h-4 w-4 animate-spin"
                                              }))
                                            : (_openBlock(), _createBlock(_unref(Send), {
                                                key: 1,
                                                class: "h-4 w-4"
                                              }))
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_51, [
                                      _createVNode(_unref(Button), {
                                        variant: "ghost",
                                        size: "sm",
                                        disabled: _unref(store).isAnalyzing,
                                        onClick: runAnalysis
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(RotateCcw), { class: "h-3.5 w-3.5 mr-1" }),
                                          _cache[24] || (_cache[24] = _createTextVNode(" Re-analizar ", -1))
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_unref(Button), {
                                        variant: "ghost",
                                        size: "sm",
                                        class: "text-muted-foreground hover:text-destructive",
                                        onClick: confirmDeleteAnalysis
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Trash2), { class: "h-3.5 w-3.5 mr-1" }),
                                          _cache[25] || (_cache[25] = _createTextVNode(" Eliminar análisis ", -1))
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(store).analysis.modelUsed), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_unref(store).isAnalyzing && !_unref(store).analysis)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                    _createVNode(_unref(Loader2), { class: "h-6 w-6 animate-spin text-primary" }),
                                    _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Analizando sesión con IA...", -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_unref(store).isLoadingFragments)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                  _createVNode(_unref(Loader2), { class: "h-5 w-5 animate-spin text-muted-foreground" })
                                ]))
                              : (_unref(store).fragments.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                    _createVNode(_unref(MessageSquareText), { class: "h-8 w-8 text-muted-foreground mx-auto mb-2" }),
                                    _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Sin fragmentos de audio", -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).fragments, (fragment, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: fragment.id,
                                        class: "p-3 border rounded-lg group"
                                      }, [
                                        _createElementVNode("div", _hoisted_57, [
                                          _createElementVNode("div", _hoisted_58, [
                                            _createVNode(_unref(Hash), { class: "h-3 w-3" }),
                                            _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                                            _createElementVNode("span", _hoisted_59, _toDisplayString(formatDuration(fragment.duration)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_60, [
                                            (editingFragmentId.value === fragment.id)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                  _createVNode(_unref(Textarea), {
                                                    modelValue: editingFragmentText.value,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editingFragmentText).value = $event)),
                                                    class: "text-sm min-h-[60px]",
                                                    onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (editingFragmentId.value = null), ["escape"]))
                                                  }, null, 8, ["modelValue"]),
                                                  _createElementVNode("div", _hoisted_62, [
                                                    _createVNode(_unref(Button), {
                                                      size: "sm",
                                                      variant: "default",
                                                      onClick: saveFragmentText
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(Check), { class: "h-3.5 w-3.5 mr-1" }),
                                                        _cache[28] || (_cache[28] = _createTextVNode(" Guardar ", -1))
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_unref(Button), {
                                                      size: "sm",
                                                      variant: "ghost",
                                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (editingFragmentId.value = null))
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                        _createTextVNode(" Cancelar ", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ])
                                                ]))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(fragment.text), 1))
                                          ]),
                                          (editingFragmentId.value !== fragment.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                _createVNode(_unref(Button), {
                                                  variant: "ghost",
                                                  size: "icon",
                                                  class: "h-7 w-7",
                                                  onClick: ($event: any) => (startEditFragment(fragment)),
                                                  title: "Editar texto"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(Pencil), { class: "h-3.5 w-3.5" })
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick"]),
                                                _createVNode(_unref(Button), {
                                                  variant: "ghost",
                                                  size: "icon",
                                                  class: "h-7 w-7 text-muted-foreground hover:text-destructive",
                                                  onClick: ($event: any) => (confirmDeleteFragment(fragment)),
                                                  title: "Eliminar fragmento"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(Trash2), { class: "h-3.5 w-3.5" })
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                          ]))
                        : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    _createVNode(_unref(AlertDialog), {
      open: showDeleteSession.value,
      "onUpdate:open": _cache[11] || (_cache[11] = ($event: any) => ((showDeleteSession).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(AlertDialogContent), { class: "z-[200]" }, {
          default: _withCtx(() => [
            _createVNode(_unref(AlertDialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(AlertDialogTitle), null, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode("Eliminar sesion", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(AlertDialogDescription), null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Se eliminara \"" + _toDisplayString(sessionToDelete.value?.name) + "\" y todos sus fragmentos. Esta accion no se puede deshacer. ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(AlertDialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(AlertDialogCancel), null, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode("Cancelar", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(AlertDialogAction), {
                  variant: "destructive",
                  onClick: doDeleteSession
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createTextVNode("Eliminar", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(AlertDialog), {
      open: showDeleteFragment.value,
      "onUpdate:open": _cache[12] || (_cache[12] = ($event: any) => ((showDeleteFragment).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(AlertDialogContent), { class: "z-[200]" }, {
          default: _withCtx(() => [
            _createVNode(_unref(AlertDialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(AlertDialogTitle), null, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createTextVNode("Eliminar fragmento", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(AlertDialogDescription), null, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode(" Se eliminara este fragmento de audio. Esta accion no se puede deshacer. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(AlertDialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(AlertDialogCancel), null, {
                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                    _createTextVNode("Cancelar", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(AlertDialogAction), {
                  variant: "destructive",
                  onClick: doDeleteFragment
                }, {
                  default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                    _createTextVNode("Eliminar", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(AlertDialog), {
      open: showDeleteAnalysis.value,
      "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((showDeleteAnalysis).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(AlertDialogContent), { class: "z-[200]" }, {
          default: _withCtx(() => [
            _createVNode(_unref(AlertDialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(AlertDialogTitle), null, {
                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                    _createTextVNode("Eliminar análisis", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(AlertDialogDescription), null, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode(" Se eliminará el análisis de esta sesión. Podrás volver a generarlo después. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(AlertDialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(AlertDialogCancel), null, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode("Cancelar", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(AlertDialogAction), {
                  variant: "destructive",
                  onClick: doDeleteAnalysis
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode("Eliminar", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})